import { useInput, Validator } from 'ra-core'
import { useCallback, useRef } from 'react'
import { ResourcePrefix } from '../controller/UploadFileContext'
import { UploadFileFormat } from '../types'
import { useSetFileRecordsFromExternal } from './useSetFileRecordsFromExternal'
import { useUpdateExternalWithFileChanges } from './useUpdateExternalWithFileChanges'

/**
 * Hook that syncs form field value with UploadFileContext file records.
 * - Converts form field value to file records and syncs to context
 * - Watches context for uploaded files and updates form field when uploads complete
 * @param formFormat - 'id' (default) outputs {id: number}, 'url' outputs URL strings
 */

export const useSyncUploadFileToField = (
  source: string,
  slot: string,
  resource_prefix: ResourcePrefix,
  multiple: boolean,
  formFormat: UploadFileFormat = 'id',
  validate?: Validator | Validator[],
  format?: (value: any) => any,
  parse?: (value: any) => any
) => {
  const {
    input: { value, onChange },
    meta,
  } = useInput({ source, validate, format, parse })

  const onChangePreview = useCallback(
    (newValue: any) => {
      // at this point only these formats provide a useful preview value
      if (formFormat === 'public_url' || formFormat === 'record') {
        onChange(newValue)
      }
    },
    [formFormat, onChange]
  )

  const previousValueRef = useRef<any>(null)

  const { isInternalUpdateRef } = useUpdateExternalWithFileChanges(
    slot,
    multiple,
    formFormat,
    previousValueRef,
    onChange,
    onChangePreview
  )

  useSetFileRecordsFromExternal(value, multiple, slot, resource_prefix, previousValueRef, isInternalUpdateRef)

  return { meta }
}
